import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import Spinner from '../components/Spinner';
import ErrorPage from '../errors/ErrorPage';
import {setPlacement, getPlacement, resetClonePlacementState, clonePlacementWithNotifications} from '../actions/placementActions';
import ClonePlacementPage from '../components/clonePlacement/ClonePlacementPage';
import {getOrder} from "../actions/orderActions";
import {countLineItems} from '../utils/countLineItems';
import { TrackingCtx  } from "../tracking";


class ClonePlacement extends Component {

  componentDidMount() {
    document.title = 'GALILEO - Clone Placement';
    const { dispatch, match, order } = this.props;
    let placement = {};
    const ioId = match.params.id;
    const id = match.params.pid;

    if (isEmpty(order) && ioId) {  // when user refreshes the page
      dispatch(getOrder(ioId)).then(() => dispatch(getPlacement(id)));
    } else {
      const placements = order.Placements;
      placement = placements.find(p => p.id === id);
      if (!isEmpty(placement)) {
        dispatch(setPlacement(placement));
      }
      if (isEmpty(placement) && id) {
        dispatch(getPlacement(id));
      }
    }
  }

  clone = (placement, placementCopies) => {
    const { dispatch, history } = this.props;
    dispatch(resetClonePlacementState());
    dispatch(clonePlacementWithNotifications(placement.id, placementCopies))
    .then(() => {
      if (this.props.error) {
        return;
      }
      history.push(`/ios/${placement.IoId}`);
    })
  };

  goBack = () => {
    const { history, placement } = this.props;
    history.push(`/ios/${placement.IoId}/placement/${placement.id}`)
  };

  render() {
    const { isFetching, order, placement, error } = this.props;
    const { itemRemainder } = countLineItems(order);

    return (
      <div>
        {isFetching && <Spinner />}
        {!isFetching && error && isEmpty(placement) && (
          <ErrorPage error={error} entity="placement" />
        )}
        {!isFetching && !isEmpty(placement) && (
          <TrackingCtx.Provider value={{category:"Placement", action:"Copy Placement Settings", label:`IO#${1} Placement#${1}`}}>
          <ClonePlacementPage
            placement={placement}
            onClone={this.clone}
            onBack={this.goBack}
            maxCopies={itemRemainder}
          />
          </TrackingCtx.Provider>
        )}
      </div>
      );
  }
}
ClonePlacement.defaultProps = {
  placement: null,
  order: null
};

ClonePlacement.propTypes = {
  placement: PropTypes.object,
  order: PropTypes.object
};

const mapStateToProps = state => {
  const { placementRequest, orderRequest } = state;
  return {
    isFetching: placementRequest.isFetching,
    placement: placementRequest.placement,
    order: orderRequest.order,
    error: placementRequest.error || orderRequest.error
  }
};

export default connect(mapStateToProps)(ClonePlacement);
